import Vue from "vue";
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import App from "./App.vue";
import ras from "./plugins/ras-kit";
import titleMixin from './mixins/title'
import router from "./router/router.js";
import { BootstrapVue} from 'bootstrap-vue';
import Markdown from 'vue3-markdown-it';
import './registerServiceWorker';
var VueScrollTo = require('vue-scrollto');
import store from "./store/index.js";
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false
Vue.use(ras);
Vue.use(Markdown);
Vue.use(VueBreadcrumbs);
Vue.use(BootstrapVue);
Vue.use(VueScrollTo);
Vue.use(VueCookies);

// mixin for handling title
Vue.mixin(titleMixin);


new Vue({
   store,
   el: '#app',
   router,   
   data:{
      mainMenu: null,
      hpLayout: null,
      statusCookie: false,      
      title:'',
      areeSpeciali: [],
      cookieContent: "",
      s3: [],
      argomenti: []
   },
   methods: {
      print: function(){
         window.print();
      },

      setCookieContent: function(content){
         this.cookieContent = content;
      },

      setMainMenu: function(menu){
         this.mainMenu = menu;
      },
      
      getMonthName(monthInt){
         const monthNames = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
         return monthNames[monthInt];
      },
      
      setHPLayout: function (data){
         this.hpLayout = data;
      }, 

      setAreeSpeciali: function(aree){
         this.$store.commit("setAreeSpeciali", aree);
         this.areeSpeciali = aree;
      },          

      setSearchArguments: function(args){         
         this.$store.commit("setSearchArguments", args);
         this.argomenti = args;
      },

      setS3Categories: function(s3Cats){
         this.$store.commit("setS3", s3Cats);
      },

      setTitle: function(title){
         this.title = title;
      },

      getLayout(){
         return this.hpLayout; 
      },

      getS3Category(id) {
         if(id == null){
            return;
         }
         let args = {};        
         let argsS3 = this.$store.getters.getS3;
         for(let i=0; i < id.length; i++){         
            args[id[i]] = argsS3.find(m => m['idFonteDati'] == id[i]);
         }      
         return args;
      },      

      getAreeSpeciali(id){
         let argsAree = store.getters.getAreeSpeciali
         let args = {};
         for(let i=0; i < id.length; i++){         
            args[id[i]] = argsAree.find(m => m['id'] == id[i]);
         }
         return args;
      }          
   },
   render: h => h(App)
}).$mount("#app");


